"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Portal", {
    enumerable: true,
    get: function() {
        return Portal;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _usePortal = require("./usePortal");
const _renderPortal = require("./renderPortal");
const Portal = (props)=>{
    const state = (0, _usePortal.usePortal_unstable)(props);
    return (0, _renderPortal.renderPortal_unstable)(state);
};
Portal.displayName = 'Portal';
